import { MenuItem } from '../interfaces/menu.interface';
export const FEATHER: string = 'feather';
export const ICONSAX: string = 'iconsax';

export const MENU: MenuItem[] = [
  {
    label: 'Main',
    isTitle: true,
  },
  {
    label: 'Dashboard',
    icon: 'home',
    iconType: FEATHER,
    link: '/dashboard',
  },
];
